import { useRef, useState, useCallback } from 'react';
import { useIntl } from 'react-intl-next';

import type { VersionHistoryNodeType } from '@confluence/version-history';
import { getFormattedDate } from '@confluence/version-history';

export type WhiteboardsVersionHistoryService = {
	versionId: string | null;
	getVersionName: () => string | null;
	setWhiteboardVersion: (version: VersionHistoryNodeType | null) => void;
};

export const useWhiteboardsVersionHistory = (): WhiteboardsVersionHistoryService => {
	const { formatDate, formatTime } = useIntl();

	const [whiteboardVersionId, setWhiteboardVersionId] = useState<string | null>(null);
	const versionName = useRef<string | null>(null);

	const getVersionName = () => versionName.current;

	const setWhiteboardVersion = useCallback(
		(version: VersionHistoryNodeType | null) => {
			setWhiteboardVersionId(version?.contentProperties?.latest?.externalVersionId || null);
			versionName.current = version
				? getFormattedDate(version.updatedTime, formatDate, formatTime)
				: null;
		},
		[formatDate, formatTime],
	);

	return { versionId: whiteboardVersionId, getVersionName, setWhiteboardVersion };
};
